import { useState } from 'react';
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import AggregateStats from './components/AggregateStats';
import CategoryFilter from './components/CategoryFilter';
import CaseStudyCard from './components/CaseStudyCard';
import CtaSection from './components/CtaSection';
import { caseStudies } from '../../mocks/caseStudies';

export default function CaseStudiesPage() {
  const [activeCategory, setActiveCategory] = useState('All Projects');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Case Studies - Real Results from Real Farms",
    "description": "See how precision aerial application and land management services have helped farmers across the region protect yield and increase profitability"
  };

  const filteredStudies =
    activeCategory === 'All Projects'
      ? caseStudies
      : caseStudies.filter((s) => s.category === activeCategory);

  return (
    <div className="min-h-screen bg-stone-50">
      <SEO
        title="Case Studies - Real Results from Real Farms | Greenfield Partners"
        description="See how precision aerial application and land management services have helped farmers across the region protect yield and increase profitability."
        keywords="agricultural case studies, drone spraying results, farm yield improvement, precision agriculture success stories"
        schema={schema}
      />
      <HeroSection />

      <AggregateStats />

      <CategoryFilter
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <section className="pb-24 px-6">
        <div className="max-w-6xl mx-auto space-y-12">
          {filteredStudies.length > 0 ? (
            filteredStudies.map((study, index) => (
              <CaseStudyCard key={study.id} study={study} index={index} />
            ))
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-folder-open-line text-5xl text-gray-300"></i>
              </div>
              <p className="text-gray-500 text-lg">
                No case studies in this category yet. Check back soon.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Gradient bridge into dark CTA */}
      <div className="h-32 bg-gradient-to-b from-stone-50 via-stone-200/40 to-[#1a1f1c]"></div>

      <CtaSection />
    </div>
  );
}
